import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, useSearchParams, Link } from 'react-router-dom';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import { Helmet } from "react-helmet-async";
import { useAuth } from '../../context/AuthContext';
import { db, doc, onSnapshot,query,collection,where,updateDoc,arrayUnion,arrayRemove } from '../../config/firebaseConfig.js'; // Pastikan jalur benar
import { documentId } from 'firebase/firestore';

const HalamanTes = () => {
    const { user, loading, logout } = useAuth();

    const location = useLocation();

    const { kode, nama_mapel, id } = location.state || {};
      const [daftaruji, setUji] = useState({});
      const [Logp, setLog] = useState({});
    console.log(location.state)

     useEffect(() => {
      if (!id) return;
     
      const unsub = onSnapshot(doc(db, "jadwal", id), (docSnap) => {
        if (docSnap.exists()) {
          setUji(docSnap.data())
          console.log("ddd",docSnap.data() );
        }
      });
    
      return () => unsub();
    }, [id]);

      useEffect(() => {
  if (!id) return;

  const q = query(
    collection(db, "logpeserta"),
    where("kode_ruang", "==", id)
  );

  const unsub = onSnapshot(q, (querySnapshot) => {
    const data = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    console.log("p",data)

    setLog(data);
  });

  return () => unsub();
}, [id]);

const handleCheckbox = async (pesertaId, checked) => {
  const ref = doc(db, "jadwal", id); // id jadwal ruang

  if (checked) {
    // TAMBAH id ke daftar_peserta
    await updateDoc(ref, {
      daftar_peserta: arrayUnion(pesertaId)
    });
  } else {
    // HAPUS id dari daftar_peserta
    await updateDoc(ref, {
      daftar_peserta: arrayRemove(pesertaId)
    });
  }
};
    const updateStatusPeserta = async (pesertaId, statusBaru) => {
  const docRef = doc(db, "jadwal", id); // id jadwal/ruang

  // Copy data peserta baru
  const pesertaBaru = daftaruji.peserta.map(p =>
    p.id === pesertaId ? { ...p, status: statusBaru } : p
  );

  await updateDoc(docRef, {
    peserta: pesertaBaru
  });
};

const handleStatusChange = async () => {
  const newStatus = daftaruji.status === "Aktif" ? "Selesai" : "Aktif";

  const result = await Swal.fire({
    title: "Konfirmasi",
    text: `Anda yakin ingin mengubah status menjadi "${newStatus}"?`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Ya, Lanjutkan",
    cancelButtonText: "Batal"
  });

  if (!result.isConfirmed) return;

  try {
    await updateDoc(doc(db, "jadwal", id), {
      status: newStatus,
      id_pengawas:user.uid
    });

    Swal.fire({
      icon: "success",
      title: "Berhasil",
      text: `Status berubah menjadi "${newStatus}"`,
      timer: 1500,
      showConfirmButton: false
    });

  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Gagal",
      text: error.message
    });
  }
};
    return (
        <div>
            <Helmet>
                <title>Identifikasi Pengguna</title>
            </Helmet>

            <div className="pc-container" style={{ backgroundColor: "#d1c4e9" }}>
                <div className="pc-content" >
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col">
                                    <div className="page-header-title"><h5 className="m-b-10">Halaman TES</h5></div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="card m-2">
                      <div className="card-header d-flex justify-content-between">
  <h6 className="m-0">
    KODE : <span className="fw-bold">{kode}</span>
  </h6>

  <button
  className={`btn ${daftaruji.status === "Aktif" ? "btn-danger" : "btn-success"} btn-sm`}
  onClick={() => handleStatusChange()}
>
  {daftaruji.status === "Aktif" ? "Akhiri Tes" : "Mulai Tes"}
</button>
</div>


                        <div className="card-body">

                            <h6>Peserta ({daftaruji?.peserta?.length })</h6>
                            <hr />

                            <table class="table table-hover">
                                <thead>
                                    <tr>
                                        <th width="50">Absensi</th>
                                        <th>Nama & Pelajaran</th>
                                        {/* <th>Progres</th> */}
                                       <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                   {daftaruji?.peserta?.map((item, index) => (
  <tr key={index}>
    <td><input
  type="checkbox"
  checked={daftaruji?.daftar_peserta?.some(p => p === item.id)}
  onChange={(e) =>
    handleCheckbox(item.id, e.target.checked)
  }
/>
</td>
    <td className={`${daftaruji?.daftar_peserta?.some(p => p === item.id)?"":"tidakaktif"}`}>
      <h6 class="mb-1">{item.nama} </h6><small>{item.nama_mapel}</small> 
    </td>

    {/* <td className={`${daftaruji?.daftar_peserta?.some(p => p === item.id)?"":"tidakaktif"}`}>
      <h6 class="mb-1">{Logp.find(l =>
  daftaruji?.peserta?.some(p => p.id === l.id)
)?.progres}</h6>
    </td> */}
    <td className={`${daftaruji?.daftar_peserta?.some(p => p === item.id)?"":"tidakaktif"}`}>
    
       <div class="btn-group">
                            <button 
                                class="btn btn-light btn-sm dropdown-toggle" 
                                type="button" 
                                data-bs-toggle="dropdown" 
                                aria-expanded="false"
                                style={{border: "none"}}>
                                {item.status || "-"}
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                                <li>
                                <a 
                                    href="#" 
                                    class="dropdown-item edit-btn" 
                                    onClick={(e) => {
    e.preventDefault();

    updateStatusPeserta(
      item.id,
      item.status === "Mulai" ? "Dikeluarkan" : "Mulai"
    );
  }}>
                                        {item.status=="Mulai"?(
                                             <><i class="ti ti-logout me-2"></i> Keluarkan</>
                                        ):(
                                             <><i class="ti ti-login me-2"></i> Beri Akses</>
                                        )}
                                   
                                </a>
                                </li>
                            </ul>
                            </div>
                                </td>
                            </tr>
                            ))}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    );
};

export default HalamanTes;